import { Navigate } from "@tanstack/react-router"

import { HOME_VIEW_ID } from "./HomeDashboardScreen/viewRegistry"

/** My Work moved to the home dashboard widget; old links (Slack, bookmarks) land on it. The view is pinned to Home,
 *  which lists the widget, so a device whose last view was VidMax still lands on it. */
function MyWorkScreen() {
  return <Navigate to="/" search={{ view: HOME_VIEW_ID, focus: "my-work" }} replace />
}

export default MyWorkScreen
